<script setup lang="ts">
import { ref } from 'vue'
import { Sun, Moon, Monitor, Check, ChevronDown } from 'lucide-vue-next'
import { useUiStore, type ThemePreference } from '@/stores/ui'
import { useAuthStore } from '@/stores/auth'
import Popover from 'primevue/popover'

const ui = useUiStore()
const auth = useAuthStore()
const popover = ref<InstanceType<typeof Popover> | null>(null)

const modes: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'theme.light', icon: Sun },
  { value: 'system', label: 'theme.auto', icon: Monitor },
  { value: 'dark', label: 'theme.dark', icon: Moon }
]

async function select(m: ThemePreference) {
  ui.themePref = m
  popover.value?.hide()
  if (auth.isAuthenticated) {
    try {
      await auth.updateTheme(m)
    } catch {
      // ignoriere
    }
  }
}
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-1 px-2 h-9 rounded-md border border-[var(--border)] hover:bg-[var(--surface-2)] text-[var(--text-2)] hover:text-[var(--text)]"
    :aria-label="$t('menu.theme')"
    @click="(e) => popover?.toggle(e)"
  >
    <Sun v-if="ui.effectiveTheme === 'light'" :size="18" />
    <Moon v-else :size="18" />
    <ChevronDown :size="14" />
  </button>

  <Popover ref="popover">
    <div class="flex flex-col gap-1 min-w-[170px]">
      <button
        v-for="m in modes"
        :key="m.value"
        type="button"
        class="flex items-center gap-2 px-3 py-2 rounded hover:bg-[var(--surface-2)] text-left"
        @click="select(m.value)"
      >
        <component :is="m.icon" :size="16" class="text-[var(--text-2)]" />
        <span class="flex-1">{{ $t(m.label) }}</span>
        <Check
          v-if="ui.themePref === m.value"
          :size="14"
          class="text-[var(--primary-500,#bfe11f)]"
        />
      </button>
    </div>
  </Popover>
</template>
